import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { GetBO } from '../../pages.modal';

@Injectable({
    providedIn: 'root'
})
export class TimesheetDateListService extends Subject<DataStateChangeEventArgs> {

    constructor(private http: HttpClient, public errorService: ErrorService,
    ) { super() }

    public execute(Timesheetstate: GetBO): void {
        this.getTimesheetList(Timesheetstate).subscribe(x => super.next(x));
    }

    getTimesheetList(Timesheetstate?: GetBO): Observable<DataStateChangeEventArgs> {
        return this.http.post<any>("api/Timesheets/GetTimesheets", Timesheetstate)
            .pipe(map(
                (response: any) =>
                    <any>{
                        result: response['timesheets'],
                        count: response['totalCount']
                    }
            ))
    }
}
